import { Box, Button, Container, Grid } from '@mui/material';
import React, { useState } from 'react';
import FormInput from '../../components/hook-form/form-input.component';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { SiTrackPage } from '../../components/si-track-page';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import * as Yup from 'yup';
import { useSaveData } from '../../hooks/useSaveData';
import { passwordApiKeyStore } from '../../api/password-api-key-store';
import { useNavigate } from 'react-router-dom';
import FormInputPassword from '../../components/hook-form/form-input-password.component';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

const validationSchema = Yup.object().shape({
  password: Yup.string().required('Current password is required'),
  newPassword: Yup.string()
    .required('New password is required')
    // Enforces minimum length
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter') // Enforces uppercase
    .matches(/^(?=.*[@$!%*?&])/, 'Password must contain at least one special character')
    .min(16, 'Password must be at least 16 characters long'),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword')], 'New password and Confirm password must match'),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  const form = useReactHookForm({
    defaultValues: {},

    yupSchema: validationSchema,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { isLoading, mutateAsync } = useSaveData<any>(passwordApiKeyStore.resetPassword());

  const handleSubmit = async (data: any) => {
    mutateAsync({
      data: {
        oldPassword: data?.password,
        newPassword: data?.newPassword,
        confirmPassword: data?.confirmPassword,
      },
    }).then((data) => {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = '/';
      }, 500); // Delay of 500ms before clearing localStorage and redirecting
    });
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <SiTrackPage title="Reset password">
      <Container style={{ maxWidth: '520px', textAlign: 'center', marginTop: 30 }}>
        <Box
          sx={{
            display: 'inline-block',
            borderRadius: '12px',
            backgroundColor: '#fff',
            padding: '60px',
            boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
          }}
        >
          <h2 style={{ marginBottom: 20, marginTop: -20 }}> Reset Password </h2>
          <ReactHookForm
            formName="EDIT_EMPLOYEE_FORM"
            onSubmit={handleSubmit}
            formContextProps={form}
            isBusy={isLoading}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                {/* <FormInput label="Current password" type="password" name="password" /> */}
                <FormInputPassword label="Password" name="password" type="password" />
              </Grid>

              <Grid item lg={12} sm={12} xl={12} xs={12}>
                {/* <FormInput label="New password" type="password" name="newPassword" /> */}
                <FormInputPassword label="New password" type="password" name="newPassword" />
              </Grid>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                {/* <FormInput label="Confirm password" type="password" name="confirmPassword" /> */}
                <FormInputPassword label="Confirm password" type="password" name="confirmPassword" />
              </Grid>
              <Grid item lg={12} sm={12} xl={12} xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                  onClick={() => navigate('/')}
                  type="button"
                  variant="outlined"
                  fullWidth
                  style={{ maxWidth: '100px' }}
                >
                  CANCEL
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isLoading || isReadOnlyPermission}
                  fullWidth
                  style={{ maxWidth: '100px' }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </ReactHookForm>
        </Box>
      </Container>
    </SiTrackPage>
  );
};

export default ResetPassword;
